import { useEffect, useRef } from "react";
import { getApiSettings, returnToOwnCompany } from "../../Api/Client.js";

// Outside a support session, platform staff belong in their own company. When a session ends without "Leave" (closed in
// another tab, or it ran out) the stored company id goes stale and the screen keeps naming the company just left. This
// puts it back and re-reads who they are, once per stale company, so a server that disagrees cannot start a reload loop.
export function useOperatorCompany(me, reload) {
  const fixedFor = useRef("");
  useEffect(() => {
    const own = me?.user?.ownCompanyId;
    if (!me?.user?.isOperator || me?.support || !own) return;
    const active = String(me?.activeTenant?.id ?? "");
    if (String(getApiSettings().tenantId) === String(own) && active === String(own)) return;
    returnToOwnCompany(own);
    if (active !== String(own) && fixedFor.current !== active) {
      fixedFor.current = active;
      reload(["me"]);
    }
  }, [me, reload]);
}
